module.exports = __webpack_public_path__ + "media/images/angle-up-c-e20f872795091d68430f083505a8cc59.png";